import { useEffect, useState } from "react";
import LoaderContainer from "../LoaderContainer/LoaderContainer.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useMail } from "contexts/mailContext/mailContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";
import { ExternalNotification } from "components/Pages/Gallery/GalleryContent/ExternalNotification.tsx";

export const useVideoPreviewAction = ({
  mailId,
  setLoading,
  setExternalNoti,
}) => {
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  const handleClick = async () => {
    setLoading(true);
    const res = await apiRequest(
      "Mails",
      "EncodedVideoByMailReact",
      {
        EncryptedMailId: mailId,
        FileId: null,
      },
      "POST"
    );
    if (res.status === "success") {
      if (res.data === "OK") {
        if (!setExternalNoti) {
          addToast(getTextByKey(`video-encode-noti-message`), {
            appearance: "success",
          });
        } else {
          setExternalNoti(true);
        }
      }
      if (res.data === "ErrorEncoding") {
        addToast(getTextByKey(`video-encode-error`), {
          appearance: "error",
        });
      }
      if (res.data === "limitReached") {
        addToast(getTextByKey(`video-encode-limit-reached`), {
          appearance: "warning",
        });
      }
      if (res.data === "without-files") {
        addToast(getTextByKey(`video-encode-no-files`), {
          appearance: "warning",
        });
      }
      if (res.data === "without-video-files") {
        addToast(getTextByKey(`video-encode-no-video`), {
          appearance: "warning",
        });
      }
      if (res.data === "all-videos-trnascoded") {
        addToast(getTextByKey(`video-encode-all-transcoded`), {
          appearance: "warning",
        });
      }
      if (res.data === "") {
        addToast(getTextByKey(`wrong-request`), {
          appearance: "error",
        });
      }
    }

    setLoading(false);
  };
  return handleClick;
};

export const VideoPreviewAction = ({ mailId }) => {
  const { getMailId } = useMail();
  const { isSubscribed } = useUser();
  const { getTextByKey, getHtmlByKey } = useContent();
  const [loading, setLoading] = useState(false);
  const [externalNoti, setExternalNoti] = useState(false);

  useEffect(() => {
    if (!externalNoti) return;
    setTimeout(() => {
      setExternalNoti(false);
    }, 5000);
  }, [externalNoti]);

  const handleClick = useVideoPreviewAction({
    mailId: getMailId(),
    setLoading,
    setExternalNoti,
  });

  return isSubscribed() ? (
    <>
      <LoaderContainer isLoading={loading}>
        <Tooltip tooltipTextKey="video-preview-tooltip-text" top>
          <Icon name="video-preview" onClick={handleClick} gray clickable />
        </Tooltip>
      </LoaderContainer>
      <ExternalNotification
        show={externalNoti}
        setShow={setExternalNoti}
        icon="arrows-repeat"
        title={getTextByKey("video-encode-noti-title")}
        message={getHtmlByKey("video-encode-noti-message")}
      />
    </>
  ) : null;
};

export default VideoPreviewAction;
